import { modals } from '@mantine/modals';
import { t } from 'i18next';

import { TwoFactorPromptForm } from './TwoFactorPromptForm';

/**
 * Asks for a two-factor code and runs `attempt` with it. A wrong code keeps the prompt open.
 * Resolves with what `attempt` returned, or with null when the user closes the prompt.
 */
export function requestTwoFactorCode<T>(description: string, attempt: (code: string) => Promise<T>): Promise<T | null> {
	return new Promise(resolve => {
		let settled = false;
		const modalId = modals.open({
			title: t('twoFactor.prompt.title'),
			onClose: () => {
				if (!settled) {
					settled = true;
					resolve(null);
				}
			},
			children: (
				<TwoFactorPromptForm
					description={description}
					attempt={attempt}
					onSuccess={value => {
						settled = true;
						resolve(value);
						modals.close(modalId);
					}}
				/>
			),
		});
	});
}
